import React from 'react';
import { Modal } from './Modal';
import { Button } from './index';

interface NavigationConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onSave: () => void;
  targetStep?: string;
  isConfirmingNavigation?: boolean;
  isSavingNavigation?: boolean;
}

export const NavigationConfirmModal: React.FC<NavigationConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  onSave,
  targetStep,
  isConfirmingNavigation = false,
  isSavingNavigation = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Unsaved Changes"
      size="md"
      closeOnBackdrop={false}
    >
      <div className="space-y-4">
        <p className="text-gray-700">
          You have unsaved changes in the current questionnaire.
          {targetStep &&
            ` Do you want to save before moving to "${targetStep}"?`}
        </p>

        <p className=" text-red-600">
          If you continue without saving, your changes will be lost.
        </p>

        <div className="flex gap-3 justify-end pt-4">
          <Button
            variant="outline"
            onClick={onConfirm}
            size="sm"
            className="text-red-600 border-red-300 hover:bg-red-50"
            disabled={isConfirmingNavigation || isSavingNavigation}
          >
            {isConfirmingNavigation
              ? 'Continuing...'
              : 'Continue Without Saving'}
          </Button>

          <Button
            onClick={onSave}
            size="sm"
            className="bg-blue-600 hover:bg-blue-700"
            disabled={isConfirmingNavigation || isSavingNavigation}
          >
            {isSavingNavigation ? 'Saving...' : 'Save & Continue'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
